import { DRAFT_TYPES } from "../globals/static-data";

export const formatPrice = (price, country = "US") => `${country}$${price}`;

export const convertStringToInt = (str) => parseInt(str, 10);

export const formatStringByDraftType = (str, type) => {
  try {
    switch (type) {
      case DRAFT_TYPES.JSON:
        const parsedStr = JSON.parse(str);
        return JSON.stringify(parsedStr, null, 2);
      default:
        const parsedJson = JSON.parse(str);
        return JSON.stringify(parsedJson);
    }
  } catch (error) {
    return str;
  }
};
